// config.js

import { ConfigInterface } from "./common/interfaces";

// Helper function to get the domain extension
const getDomainExtension = (): string | undefined => {
  if (!window.location.hostname.includes("kompare")) return undefined;
  const parts = window.location.hostname.split(".");
  return parts[parts.length - 1];
};

const getEnvVars = (): ConfigInterface => {
  const domainExtension: string | undefined = getDomainExtension();

  if (!domainExtension) return {
    REACT_APP_IS_DEV: process.env.REACT_APP_IS_DEV ?? '',
    REACT_APP_URL: process.env.REACT_APP_URL ?? '',
    REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? '',
    REACT_APP_DMS_URL: process.env.REACT_APP_DMS_URL ?? '',
    REACT_APP_KOMPARE_HOME: process.env.REACT_APP_KOMPARE_HOME ?? '',
    REACT_APP_WSPAY_URL: process.env.REACT_APP_WSPAY_URL ?? '',
    REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT ?? '',
    PORT: 3002,
  };

  const baseUrl: string = domainExtension === "hr" ? "https://zdravstveno.kompare." : "https://dzo-webshop.kompare.";
  const wsPayUrl: string = domainExtension === "hr" ? "https://form.wspay.biz/authorization.aspx" : "https://formtest.wspay.biz/authorization.aspx";
  const isDev: boolean = domainExtension !== "hr";

  return {
    REACT_APP_IS_DEV: isDev ? "true" : "false",
    REACT_APP_URL: `${baseUrl}${domainExtension}`,
    REACT_APP_API_URL: `https://public-api-proxy.kompare.${domainExtension}`,
    REACT_APP_DMS_URL: `https://minio.kompare.hr`,
    REACT_APP_KOMPARE_HOME: `https://kompare.hr`,
    REACT_APP_WSPAY_URL: wsPayUrl,
    REACT_APP_ENVIRONMENT: domainExtension === "hr" ? "production" : domainExtension,
    PORT: 3003,
  };
};

const config: ConfigInterface = (() => getEnvVars())();

export default config;
